import { createApi } from '@reduxjs/toolkit/query/react';

import {
  ClientsMergeEndpoints as Endpoints,
  type CheckClientForDuplicateRequest,
  type CheckClientForDuplicateResponse,
  type MergeClientsAtSameBranchRequest,
  type MergeClientsAtSameBranchResponse,
} from '@app/api/ClientsMerge/types';
import { createApiBaseQuery, Methods } from '@app/api/shared';
import { CLIENTS_MERGE_CHUNK } from '@app/constants';

export const clientsMergeApi = createApi({
  reducerPath: 'clientsMergeApi',
  baseQuery: createApiBaseQuery(CLIENTS_MERGE_CHUNK),
  endpoints: ({ mutation }) => ({
    [Endpoints.CheckClientForDuplicate]: mutation<
      CheckClientForDuplicateResponse,
      CheckClientForDuplicateRequest
    >({
      query: ({ data, ...params }) => ({
        url: Endpoints.CheckClientForDuplicate,
        method: Methods.POST,
        params,
        data,
      }),
    }),
    [Endpoints.MergeClientsAtSameBranch]: mutation<
      MergeClientsAtSameBranchResponse,
      MergeClientsAtSameBranchRequest
    >({
      query: ({ data, ...params }) => ({
        url: Endpoints.MergeClientsAtSameBranch,
        method: Methods.POST,
        params,
        data,
      }),
    }),
  }),
});

export const {
  useCheckClientForDuplicateMutation,
  useMergeClientsAtSameBranchMutation,
} = clientsMergeApi;
